import { useEffect } from "react";

import { Outlet, useLocation } from "react-router-dom";

import { Environment, environment, GTMURL } from "../config";
import { LoadScript } from "../lib/LoadScript";

export const LoadGTMLayout = () => {
  const { search } = useLocation();

  useEffect(() => {
    if (!(environment === Environment.DEV)) {
      LoadScript({
        id: "tagmanager",
        url: GTMURL,
        async: true,
      });
    } else {
      console.info(`%cGTM script not loaded`, "color: #a0a000; font-weight: bold;");
    }
  }, [search]);

  return <Outlet />;
};
